import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBoxSaleContextOperationsResponse } from './admin-box-sale-context-operations.response';
import { AdminBoxSaleGroupResponse } from './admin-box-sale-group.response';
import { AdminBoxSaleVariantResponse } from './admin-box-sale-variant.response';

@jsonObject
export class AdminBoxSaleDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(Number)
  public readonly validityHours!: number;

  @jsonMember(String)
  public readonly description?: Nillable<string>;

  @jsonMember(AdminBoxSaleContextOperationsResponse)
  public readonly contextOperations!: AdminBoxSaleContextOperationsResponse;

  @jsonArrayMember(AdminBoxSaleGroupResponse)
  public readonly groups!: AdminBoxSaleGroupResponse[];

  @jsonArrayMember(AdminBoxSaleVariantResponse)
  public readonly variants!: AdminBoxSaleVariantResponse[];
}
